// @flow
import type { Auction } from './types'
import PropTypes from 'prop-types'
import {
  compose,
  setPropTypes,
  withProps,
  lifecycle,
  withStateHandlers
} from 'recompose'
import { MINUTE, calculateTimeFromNow } from '../../core/moment'
import { t } from '../../core/i18n'
import { AUCTION_STATE } from './constants'

const withPropTypes = setPropTypes({
  auction: PropTypes.object.isRequired
})

const getCountdownTimes = (auction: Auction): ?Object => {
  if (!auction) return
  const result = {
    start: calculateTimeFromNow(auction.startTime),
    end: calculateTimeFromNow(auction.closeTime)
  }
  return result
}

type RecievedPropTypes = {
  auction: Auction
}

type InternalState = {
  countdownTimes: { start: string, end: string }
}

const withCountdownState = withStateHandlers(
  (props: RecievedPropTypes): Object => ({
    countdownTimes: getCountdownTimes(props.auction) || ''
  }),
  {
    updateCountdownTimes: (
      state: InternalState,
      props: RecievedPropTypes
    ) => () => ({
      countdownTimes: getCountdownTimes(props.auction)
    })
  }
)

const withAutoCountdown = lifecycle({
  componentDidMount() {
    const { updateCountdownTimes, auction } = this.props

    if (auction.state !== AUCTION_STATE.CLOSED) {
      this.interval = setInterval(updateCountdownTimes, MINUTE)
    }
  },
  componentWillUnmount() {
    clearInterval(this.interval)
  },
  componentWillReceiveProps(nextProps) {
    const { auction } = nextProps
    if (
      auction.state !== AUCTION_STATE.CLOSED &&
      this.props.auction.id !== auction.id
    ) {
      this.props.updateCountdownTimes()
    }
  }
})

const withItemCountdownText = withProps(props => {
  if (props.auction.state === AUCTION_STATE.CLOSED)
    return {
      itemCountdownText: '',
      auctionCountdownText: ''
    }
  return {
    itemCountdownText: t(
      `item.countdown.${props.auction.state}`,
      props.countdownTimes
    ),
    auctionCountdownText: t(
      `auction.countdown.${props.auction.state}`,
      props.countdownTimes
    )
  }
})

const withAuctionCountdown = compose(
  withPropTypes,
  withCountdownState,
  withItemCountdownText,
  withAutoCountdown
)

export default withAuctionCountdown



// WEBPACK FOOTER //
// ./src/services/auction/withAuctionCountdown.js